/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
// tslint:disable: max-line-length
import { Component, inject } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';
import { CardInstance } from '@workflow/class/card.service';
import { FlowInstance } from '@workflow/class/flow.service';
import { PageInstance } from '@workflow/class/page.service';
import { CoreCardBaseComponent } from '@workflow/dynamic-render/card/shared/core-card-base.component';
import { CoreCustomCard } from '@workflow/dynamic-render/card/shared/core-custom-card.decorator';

export type StatusFlag = 'in-progress' | 'is-error';

@CoreCustomCard('autofill-preview')
@Component({
  selector: 'ecp-autofill-preview',
  styleUrls: ['./autofill-preview.component.scss'],
  templateUrl: './autofill-preview.component.html'
})
export class AutofillPreviewComponent extends CoreCardBaseComponent {
  private readonly statefulService = inject(StatefulService);

  public get editRouteLink() {
    const path = this.page.config.path ? this.page.config.path : this.page.id;
    return [`/${this.page.flowId}/${path}`.replace('-#', `/${this.page.pageIterationId}`)];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public editUrlFn = (page: PageInstance, flow: FlowInstance, card: CardInstance) => {
    this.statefulService.wrap('mem:edit-' + this.card.id).value = true;
  };

  public getReviewCards(): CardInstance[] {
    return this.page.cards.filter((card) => !card.hideInReview && card.visible);
  }
}
